import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button } from "reactstrap";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { withStyles } from "@material-ui/core/styles";
import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";
import SentimentSatisfiedAlt from "@material-ui/icons/SentimentSatisfiedAlt";
import SentimentSatisfied from "@material-ui/icons/SentimentSatisfied";
import SentimentVeryDissatisfied from "@material-ui/icons/SentimentVeryDissatisfied";
import MoodBad from "@material-ui/icons/MoodBad";
import AlertModal from "../../../../shared/components/Modal";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DigitalSignature from "../../../DigitalSignature/DigitalSignature";
import { faFileSignature } from "@fortawesome/free-solid-svg-icons";

const MedicalRadio = withStyles({
  root: {
    color: "#4CE1B6",
    "&$checked": {
      color: "#4CE1B6",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const SurveyPatientForm = ({ surveyExistData }) => {
  const [errors, setErrors] = useState({});
  const [disabledFields, setDisabledFields] = useState(false);

  const [namePatient, setNamePatient] = useState(null);
  const [firstLastName, setFirstLastName] = useState(null);
  const [secondLastName, setSecondLastName] = useState(null);
  const [numberDocument, setNumberDocument] = useState(null);
  const [typeDocument, setTypeDocument] = useState(null);
  const [emailPatient, setEmailPatient] = useState(null);
  const [phonePatient, setPhonePatient] = useState(null);
  const [idHistory, setIdHistory] = useState(null);
  const [dataQuestionsSatisfaction, setDataQuestionsSatisfaction] = useState(
    []
  );
  const [dataQuestionsRecomendations, setDataQuestionsRecomendations] =
    useState([]);
  const [observation, setObservation] = useState(null);

  const [colorAlertModal, setColorAlertModal] = useState(null);
  const [messagAlerteModal, setMessageModal] = useState(null);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [patientSignature, setPatientSignature] = useState(null);
  const [openSignaturePatient, setOpenSignaturePatient] = useState(null);

  useEffect(() => {
    loadingSurveyData();
  }, []);
  console.log("patientSignature", patientSignature);

  const loadingSurveyData = async () => {
    if ((surveyExistData != null) & (surveyExistData != undefined)) {
      setLoading(true);
      setNumberDocument(surveyExistData.num_documento);
      await loadPatientInfo(surveyExistData.num_documento)
        .then(() => {
          setDataQuestionsSatisfaction(
            surveyExistData.preguntas_satisfaccion.encuesta_satisfaccion
          );
          setDataQuestionsRecomendations(
            surveyExistData.preguntas_recomendacion.encuesta_recomendacion
          );
          //setObservation(surveyExistData.observacion);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      await loadQuestions();
    }
  };

  const loadPatientInfo = async (num_documento) => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({ num_documento: num_documento }),
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Data");
        }
      })
      .then((data) => {
        console.log("patientInfo", data);
        if (data.existe) {
          setNamePatient(data.contenido[0].nombres);
          setFirstLastName(data.contenido[0].apellido1);
          setSecondLastName(data.contenido[0].apellido2);
          setTypeDocument(data.contenido[0].tip_documento);
          setEmailPatient(data.contenido[0].correo);
          setPhonePatient(
            data.contenido[0].celular || data.contenido[0].telefono1
          );
          setIdHistory(data.contenido[0].id_historia);
        } else {
          setNamePatient("");
          setFirstLastName("");
          setSecondLastName("");
          setTypeDocument("");
          setEmailPatient("");
          setPhonePatient("");
          setIdHistory(null);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadQuestions = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "encuesta-item/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Data");
        }
      })
      .then((data) => {
        setDataQuestionsSatisfaction(data.filter((dat) => dat.tipo == 1));
        setDataQuestionsRecomendations(data.filter((dat) => dat.tipo == 2));
      })
      .catch((error) => {
        setDataQuestionsSatisfaction([]);
        setDataQuestionsRecomendations([]);
        console.error("Error:", error);
      });
  };

  const handleChangeAnswerSatisfaction = (value, index) => {
    let dataQuestionArray = dataQuestionsSatisfaction.concat([]);
    dataQuestionArray[index].respuesta = value;
    setDataQuestionsSatisfaction(dataQuestionArray);
  };

  const handleChangeAnswerRecomendation = (value, index) => {
    let dataQuestionArray = dataQuestionsRecomendations.concat([]);
    dataQuestionArray[index].respuesta = value;
    setDataQuestionsRecomendations(dataQuestionArray);
  };

  const onOkAlertModal = () => {
    if (colorAlertModal == "success") {
      setColorAlertModal(null);
      setMessageModal(null);
      setShowAlertModal(false);
      setNamePatient("");
      setFirstLastName("");
      setSecondLastName("");
      setTypeDocument("");
      setEmailPatient("");
      setPhonePatient("");
      setNumberDocument("");
      setIdHistory(null);
      loadQuestions();
      setObservation("");
      setPatientSignature(null)
    } else {
      setColorAlertModal(null);
      setMessageModal(null);
      setShowAlertModal(false);
    }
  };

  const cleanAlertModal = () => {
    setColorAlertModal(null);
    setMessageModal(null);
    setShowAlertModal(false);
  };

  const validate = () => {
    if (idHistory == null || idHistory == "") {
      setColorAlertModal("danger");
      setMessageModal("El Paciente debe estar registrado en el sistema");
      setShowAlertModal(true);
      return true;
    }

    if (numberDocument == null || numberDocument == "") {
      setColorAlertModal("danger");
      setMessageModal("El Número de Documento es Obligatorio");
      setShowAlertModal(true);
      return true;
    }

    if (
      dataQuestionsSatisfaction.some(
        (dat) => dat.respuesta == null || dat.respuesta == ""
      )
    ) {
      setColorAlertModal("danger");
      setMessageModal(
        "Es necesario contestar todas las preguntas de satisfacción"
      );
      setShowAlertModal(true);
      return true;
    }

    if (
      dataQuestionsRecomendations.some(
        (dat) => dat.respuesta == null || dat.respuesta == ""
      )
    ) {
      setColorAlertModal("danger");
      setMessageModal(
        "Es necesario contestar todas las preguntas de recomendación"
      );
      setShowAlertModal(true);
      return true;
    }

    if (patientSignature == null) {
      setColorAlertModal("danger");
      setMessageModal(
        "No puede generar la encuesta sin la firma del Paciente"
      );
      setShowAlertModal(true);
      return true;
    }

    return false;
  };

  const saveSurvey = async () => {
    if (!validate()) {
      await fetch(
        process.env.REACT_APP_PUBLIC_URL + "encuesta-paciente/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify({
            id_historia: idHistory,
            preguntas_satisfaccion: dataQuestionsSatisfaction,
            preguntas_recomendacion: dataQuestionsRecomendations,
            observacion: observation,
            fecha_encuesta: moment()
              .tz("America/Bogota")
              .format("YYYY-MM-DD HH:mm:ss"),
            firma_paciente: patientSignature,
          }),
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.text();
          } else {
            throw new Error("Data");
          }
        })
        .then((data) => {
          setColorAlertModal("success");
          setMessageModal("Encuesta contestada correctamente");
          setShowAlertModal(true);
        })
        .catch((error) => {
          setColorAlertModal("danger");
          setMessageModal("Ha ocurrido un error en el servidor");
          setShowAlertModal(true);
          console.error("Error:", error);
        });
    }
  };

  return (
    <Fragment>
      {loading == true ? (
        <div className="text-center">
          <Spinner animation="border" variant="success" />
        </div>
      ) : (
        <Row>
          <Col md={12}>
            <div
              style={{
                border: "1px solid #B2B8BF",
                marginTop: 5,
                borderRadius: 5,
              }}
            >
              <Container className="container-fluid">
                <b style={{ margin: 2 }}> Datos Basicos del Paciente</b>
                <br />
                <br />
                <Row>
                  <Col md={4}>
                    <TextField
                      style={{ width: "100%" }}
                      className="medical-material-form__field"
                      id="number-document"
                      label="Número de Documento"
                      type="text"
                      disabled={
                        surveyExistData != null && surveyExistData != undefined
                          ? true
                          : false
                      }
                      value={numberDocument}
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink:
                          numberDocument != null &&
                          numberDocument != undefined &&
                          numberDocument != ""
                            ? true
                            : false,
                      }}
                      onChange={(e) => {
                        setNumberDocument(e.target.value);
                      }}
                      onBlur={() => {
                        loadPatientInfo(numberDocument);
                      }}
                      error={
                        errors.hasOwnProperty("numberDocument")
                          ? errors.numberDocument !== ""
                          : false
                      }
                      helperText={errors.numberDocument}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      className="medical-material-form__field"
                      label="Tipo de Documento"
                      id="type-documentn"
                      style={{ width: "100%" }}
                      select
                      disabled={true}
                      value={typeDocument}
                      onChange={(event) => {
                        setTypeDocument(event.target.value);
                      }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink:
                          typeDocument != null &&
                          typeDocument != undefined &&
                          typeDocument != ""
                            ? true
                            : false,
                      }}
                      error={
                        errors.hasOwnProperty("typeDocument")
                          ? errors.typeDocument !== ""
                          : false
                      }
                      helperText={errors.typeDocument}
                    >
                      <MenuItem key={0} value={"CC"}>
                        CEDULA DE CIUDADANIA
                      </MenuItem>
                      <MenuItem key={1} value={"CE"}>
                        CEDULA DE EXTRANJERIA
                      </MenuItem>
                      <MenuItem key={2} value={"PA"}>
                        PASAPORTE
                      </MenuItem>
                      <MenuItem key={3} value={"CD"}>
                        CARNET DIPLOMATICO
                      </MenuItem>
                      <MenuItem key={4} value={"SC"}>
                        SALVO CONDUCTO
                      </MenuItem>
                    </TextField>
                  </Col>
                  <Col md={4}>
                    <TextField
                      style={{ width: "100%" }}
                      className="medical-material-form__field"
                      id="name-patient"
                      label="Nombres"
                      disabled={true}
                      type="text"
                      value={namePatient}
                      onChange={(e) => {
                        setNamePatient(e.target.value);
                      }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink:
                          namePatient != null &&
                          namePatient != undefined &&
                          namePatient != ""
                            ? true
                            : false,
                      }}
                      error={
                        errors.hasOwnProperty("namePatient")
                          ? errors.namePatient !== ""
                          : false
                      }
                      helperText={errors.namePatient}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      style={{ width: "100%" }}
                      className="medical-material-form__field"
                      id="first-last-name-patient"
                      label="Primer Apellido"
                      disabled={true}
                      type="text"
                      value={firstLastName}
                      onChange={(e) => {
                        setFirstLastName(e.target.value);
                      }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink:
                          firstLastName != null &&
                          firstLastName != undefined &&
                          firstLastName != ""
                            ? true
                            : false,
                      }}
                      error={
                        errors.hasOwnProperty("firstLastName")
                          ? errors.firstLastName !== ""
                          : false
                      }
                      helperText={errors.firstLastName}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      style={{ width: "100%" }}
                      className="medical-material-form__field"
                      id="second-last-name-patient"
                      label="Segundo Apellido"
                      disabled={true}
                      type="text"
                      value={secondLastName}
                      onChange={(e) => {
                        setSecondLastName(e.target.value);
                      }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink:
                          secondLastName != null &&
                          secondLastName != undefined &&
                          secondLastName != ""
                            ? true
                            : false,
                      }}
                      error={
                        errors.hasOwnProperty("secondLastName")
                          ? errors.secondLastName !== ""
                          : false
                      }
                      helperText={errors.secondLastName}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      style={{ width: "100%" }}
                      className="medical-material-form__field"
                      id="email-patient"
                      label="Correo"
                      disabled={true}
                      type="email"
                      value={emailPatient}
                      onChange={(e) => {
                        setEmailPatient(e.target.value);
                      }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink:
                          emailPatient != null &&
                          emailPatient != undefined &&
                          emailPatient != ""
                            ? true
                            : false,
                      }}
                      error={
                        errors.hasOwnProperty("emailPatient")
                          ? errors.emailPatient !== ""
                          : false
                      }
                      helperText={errors.emailPatient}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      style={{ width: "100%" }}
                      className="medical-material-form__field"
                      id="phone-patient"
                      label="Telefono"
                      disabled={true}
                      type="text"
                      value={phonePatient}
                      onChange={(e) => {
                        setPhonePatient(e.target.value);
                      }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                        shrink:
                          phonePatient != null &&
                          phonePatient != undefined &&
                          phonePatient != ""
                            ? true
                            : false,
                      }}
                      error={
                        errors.hasOwnProperty("phonePatient")
                          ? errors.phonePatient !== ""
                          : false
                      }
                      helperText={errors.phonePatient}
                    />
                  </Col>
                </Row>
                <br />
              </Container>
            </div>
          </Col>
          <Col md={12}>
            <div
              style={{
                border: "1px solid #B2B8BF",
                marginTop: 5,
                borderRadius: 5,
              }}
            >
              <Container className="container-fluid">
                <b style={{ margin: 2 }}> Datos de la Encuesta</b>
                <br />
                <br />
                {dataQuestionsSatisfaction.map((datQuestion, index) => {
                  return (
                    <Row>
                      <Col md={6}>
                        <FormLabel style={{ color: "black" }} disabled={true}>
                          <label>
                            {dataQuestionsSatisfaction[index].respuesta ==
                            "MUY BUENA" ? (
                              <InsertEmoticonIcon
                                style={{ color: "#ECD814" }}
                              />
                            ) : dataQuestionsSatisfaction[index].respuesta ==
                              "BUENA" ? (
                              <SentimentSatisfiedAlt
                                style={{ color: "#ECD814" }}
                              />
                            ) : dataQuestionsSatisfaction[index].respuesta ==
                              "REGULAR" ? (
                              <SentimentSatisfied
                                style={{ color: "#ECD814" }}
                              />
                            ) : dataQuestionsSatisfaction[index].respuesta ==
                              "MALA" ? (
                              <SentimentVeryDissatisfied
                                style={{ color: "#ECD814" }}
                              />
                            ) : dataQuestionsSatisfaction[index].respuesta ==
                              "MUY MALA" ? (
                              <MoodBad style={{ color: "#ECD814" }} />
                            ) : null}{" "}
                            {datQuestion.item}
                          </label>
                        </FormLabel>
                      </Col>
                      <Col md={6}>
                        <FormControl component="fieldset">
                          <RadioGroup
                            onChange={(e) => {
                              handleChangeAnswerSatisfaction(
                                e.target.value,
                                index
                              );
                            }}
                            row
                            aria-label="position"
                            id={`question${datQuestion.id_encuesta_item}`}
                            name={`question${datQuestion.id_encuesta_item}`}
                            value={dataQuestionsSatisfaction[index].respuesta}
                          >
                            <FormControlLabel
                              value="MUY BUENA"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Muy Buena</label>}
                            />
                            <FormControlLabel
                              value="BUENA"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Buena</label>}
                            />
                            <FormControlLabel
                              value="REGULAR"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Regular</label>}
                            />
                            <FormControlLabel
                              value="MALA"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Mala</label>}
                            />
                            <FormControlLabel
                              value="MUY MALA"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Muy Mala</label>}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Col>
                    </Row>
                  );
                })}

                <br />
                <hr />

                {dataQuestionsRecomendations.map((datQuestion, index) => {
                  return (
                    <Row>
                      <Col md={6}>
                        <FormLabel style={{ color: "black" }} disabled={true}>
                          <label>{datQuestion.item}</label>
                        </FormLabel>
                      </Col>
                      <Col md={6}>
                        <FormControl component="fieldset">
                          <RadioGroup
                            onChange={(e) => {
                              handleChangeAnswerRecomendation(
                                e.target.value,
                                index
                              );
                            }}
                            row
                            aria-label="position"
                            id={`question${datQuestion.id_encuesta_item}`}
                            name={`question${datQuestion.id_encuesta_item}`}
                            value={dataQuestionsRecomendations[index].respuesta}
                          >
                            <FormControlLabel
                              value="DEFINITIVAMENTE SI"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Definitivamente SI</label>}
                            />
                            <FormControlLabel
                              value="PROBABLEMENTE SI"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Probablemente SI</label>}
                            />
                            <FormControlLabel
                              value="PROBABLEMENTE NO"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Probablemente NO</label>}
                            />
                            <FormControlLabel
                              value="DEFINITIVAMENTE NO"
                              control={
                                <MedicalRadio
                                  disabled={
                                    surveyExistData != null &&
                                    surveyExistData != undefined
                                      ? true
                                      : false
                                  }
                                  size="small"
                                />
                              }
                              label={<label>Definitivamente NO</label>}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Col>
                    </Row>
                  );
                })}

                <br />
                <hr />

                <div className="form">
                  <span
                    className="form__form-group-label"
                    style={{ marginRight: 10, width: "100%" }}
                  >
                    Observación
                  </span>
                  <div className="form__form-group-field">
                    <textarea
                      id="textarea-observation"
                      value={observation}
                      disabled={
                        surveyExistData != null && surveyExistData != undefined
                          ? true
                          : false
                      }
                      name="textarea-receipt"
                      onChange={(e) => {
                        setObservation(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <br />
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn btn-sm"
                    onClick={() => {
                      setOpenSignaturePatient(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faFileSignature} /> Firma del
                    Paciente
                  </Button>
                  {patientSignature != null ? (
                    <img
                      style={{ width: 200, height: 60 }}
                      src={patientSignature}
                    />
                  ) : null}
                  <DigitalSignature
                    openModalSignature={openSignaturePatient}
                    closeModalSignature={() => setOpenSignaturePatient(false)}
                    confirmSign={(value) => {
                      setPatientSignature(value);
                    }}
                    signature={patientSignature}
                  />
                </div>

                {surveyExistData == null || surveyExistData == undefined ? (
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn btn-primary text-white"
                    onClick={() => {
                      saveSurvey();
                    }}
                  >
                    Guardar
                  </Button>
                ) : null}

                <br />
                <br />
              </Container>
            </div>
          </Col>
        </Row>
      )}

      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => {
          onOkAlertModal();
        }}
        toggle={() => {
          cleanAlertModal();
        }}
      />
    </Fragment>
  );
};

export default SurveyPatientForm;
